<template>
  <label
    class="flex justify-between gap-2 rounded-xl border border-gray-100 p-4 font-bold text-gray-900"
    :for="`id${option.value}`"
  >
    {{ option.name }}

    <input
      :id="`id${option.value}`"
      class="accent-base-500 h-6 w-6"
      name="option"
      type="radio"
      :value="option.value"
      @change="sendValue"
    />
  </label>
</template>

<script>
  export default {
    name: 'RenderOption',
    props: {
      option: {
        type: Object,
        required: true,
      },
    },
    emits: ['onSelect'],
    methods: {
      sendValue() {
        this.$emit('onSelect', this.option);
      },
    },
  };
</script>
